import { render } from "./DUserDropdown.vue?vue&type=template&id=3c125176&scoped=true"
import script from "./DUserDropdown.vue?vue&type=script&lang=js"
export * from "./DUserDropdown.vue?vue&type=script&lang=js"

import "./DUserDropdown.vue?vue&type=style&index=0&id=3c125176&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c125176"]])

export default __exports__